import { getTheme, IStyle, mergeStyleSets } from "@fluentui/react";

export const getBwjPageHeaderStyles = () => {
  const theme = getTheme();

  const header: IStyle = {
    padding: 0,
    paddingTop: 30,
  };

  const title: IStyle = {
    margin: '0 20px',
    padding: 0,
  };

  const subtitle: IStyle = {
    margin: '0 20px',
    marginTop: '0.5rem',
    padding: 0,
    fontSize: theme.fonts.smallPlus.fontSize,
    lineHeight: theme.fonts.smallPlus.lineHeight,
    fontWeight: 600,
  };

  const buttonRow: IStyle = {
    marginTop: 20,
    minHeight: 40,
    display: 'flex',
    flexDirection: 'row',
    flexFlow: 'nowrap',
    alignItems: 'center',
  };

  const menuToggleTray: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
  };

  const actionButtonTray: IStyle = {
    margin: '0 20px',
    flexGrow: 1,
    borderBottom: `1px solid ${theme.palette.neutralTertiary}`,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  };

  const menuSlot: IStyle = {
    width: 220,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  };

  const collaspedMenuSlot: IStyle = {
    width: 70,
  };

  return mergeStyleSets({
    header,
    title,
    subtitle,
    buttonRow,
    menuToggleTray,
    actionButtonTray,
    menuSlot,
    collaspedMenuSlot,
  });
}
